import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Card, Icon, Modal, Input } from '@ui-kitten/components';
import { StyleSheet, View, Image, Dimensions, ScrollView, TouchableOpacity } from 'react-native';
import moment from 'jalali-moment'
import * as RootNavigation from '../../../root.navigation.js';
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useDispatch } from 'react-redux';
import { useIsFocused } from "@react-navigation/native";
import JalaliCalendarPicker from 'react-native-persian-jalali-calendar-picker';


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;

const NewTask = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='alert-circle'/>
);
const Eye = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='eye'/>
);
const Flag = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='flag'/>
);
const Flash = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='flash'/>
);


const FilterFillIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#134A93'
    name='funnel'/>
);


const FilterIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#134A93'
    name='funnel-outline'/>
);

export const PaymentList = ({ navigation }) => {
  const isVisible = useIsFocused();
  const [data, setData] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const [selectedStartDate, setSeletedStartDate] = React.useState(null)
  const [selectedFinishDate, setSeletedFinishDate] = React.useState(null)
  const [selectedDate, setSeletedDate] = React.useState(null)
  const [dateModal, setDateModal] = React.useState(false)
  const [filtered, setFiltered] = React.useState(false)

  const dispatch = useDispatch();
  const getData = async ()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/agent/payments',{
      sort: 'desc',
      sortColumn: 'agentPayDate',
      page: 1,
      perPage: 1000,
      status: '',

    }, {
      headers: {Authorization: `Bearer ${token}`}
    });
    console.log(response.data);
    if(response.data.status) setData(response.data.payments);
    else showMessage({
          message: `خطای دیتابیس 1`,
          type: "danger",
        });
  }

  React.useEffect(()=>{
    getData()
  },[isVisible])

  const filterResults = async()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.post('/agent/payments',{
      sort: 'desc',
      sortColumn: 'agentPayDate',
      page: 1,
      perPage: 1000,
      status: '',
      startDate: selectedStartDate,
      finishDate: selectedFinishDate
    }, {
      headers: {Authorization: `Bearer ${token}`}
    });
    if(response.data.status) {
      setData(response.data.payments)
    }
    else showMessage({
          message: `خطای دیتابیس 1`,
          type: "danger",
        });
    setFiltered(true)
    setModal(false)
  }
  return (
    <Layout level='2' style={{flex:1}}>
    <SafeAreaView>
    <View style={{alignItems:'center', justifyContent:'space-between', height, paddingBottom:20}}>
    <Text status='primary' category='h6' style={{marginTop:25,  marginBottom:10, textAlign:'center'}}>لیست پرداختی ها</Text>
    <Divider />
    <ScrollView>
    <TouchableOpacity onPress={()=>{
      if(!filtered) setModal(true)
      else {
        getData()
        setFiltered(false)
      }
    }} style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-end', marginTop:20}}>
      <Text status='primary' style={{ textAlign:'center'}}>فیلتر</Text>
      {filtered ? <FilterFillIcon /> : <FilterIcon />}
    </TouchableOpacity>
    { data && data.length > 0 ? data.map((data)=>{
        return(
          <Card style={styles.card} key={data.id}>
            <View style={styles.cardLayout} >

              <View style={styles.centerContainer}>

              <View style={{marginHorizontal:10, maxWidth: width*0.55}}>
                <Text>مبلغ: {data.agentShare} ریال</Text>
                <Text category='c2' appearance='hint'>شماره پیگیری: {data.agentTraceNo}</Text>
                <Text category='c2' appearance='hint'>{data.agentDesc}</Text>
</View>
              </View>
              <View style={styles.leftContainer}>
                <Text category='c2' appearance='hint'>{data.agentPayDate}</Text>
                <Text category='c2' status='primary'>فاکتور {data.request_id}</Text>
              </View>
            </View>
          </Card>
        )
      }) :
        <View style={{alignItems:'center', paddingTop: 10}}>
        <Image source= {require('../../../assets/signup.png')} style={{width:width*0.5, height:width*0.5}} />
        <Text appearance='hint' style={{margin:25, textAlign:'center'}}>پرداختی برای نمایش وجود ندارد.</Text>
        </View>
    }
    </ScrollView>
    <Button onPress={()=>{RootNavigation.navigate('Menu')}} appearance='outline' style={{borderRadius:10, marginBottom:5, width: width-30}}>بازگشت</Button>
    </View>
    <Modal
       visible={modal}
       style={{width:width-20}}
       backdropStyle={styles.backdrop}
       onBackdropPress={() => setModal(false)}>
       <Card disabled={false} style={{padding:10}}>
       <Text style={{marginBottom:10}} category='h6' status='primary'>فیلتر و جستجو</Text>
       <Input
          placeholder='جستجو'
          label='شماره کار، نام مشتری و یا شماره تماس مشتری را وارد نمایید.'
          value={search}
          onChangeText={nextValue => setSearch(nextValue)}
        />
        <Text style={{marginTop:20}} appearance='hint' category='c1'>جستجوی بازه زمانی:</Text>
        <View style={{flexDirection:'row', alignItems:'center', justifyContent:'space-around', marginTop:15}}>
        <View style={{flexDirection:'row', alignItems:'center'}}>
        <Text style={{}}> از </Text>
        <Button size='small' appearance='outline' onPress={()=>{setDateModal(true);setSeletedDate('start')}}>{selectedStartDate?selectedStartDate:'انتخاب کنید'}</Button>
        </View>
        <View style={{flexDirection:'row', alignItems:'center'}}>
        <Text style={{}}> تا </Text>
        <Button size='small' appearance='outline' onPress={()=>{setDateModal(true);setSeletedDate('finish')}}>{selectedFinishDate?selectedFinishDate:'انتخاب کنید'}</Button>
        </View>
        </View>


         <View style={{flexDirection:'row', justifyContent:'flex-end'}}>

         <Button style={{marginTop:25, flex:1}} onPress={filterResults}>
            جستجو
          </Button>
          </View>
       </Card>
     </Modal>
     <Modal
        visible={dateModal}
        style={{width:width-20}}
        backdropStyle={styles.backdrop}
        onBackdropPress={() => setDateModal(false)}>
        <Card disabled={false} style={{backgroundColor:'#f5f5f5'}}>
        <JalaliCalendarPicker onDateChange={date => {
          if(selectedDate=='start') setSeletedStartDate(date)
          else setSeletedFinishDate(date)
          setDateModal(false)
          }
        }
          headerStyleText={{fontFamily: 'IRANYekanBold'}}
          weekStyleText={{fontFamily: 'IRANYekanBold'}}
          headerStyleTextCenter={{fontFamily: 'IRANYekanBold'}}
        />
        </Card>
      </Modal>
    </SafeAreaView>

    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  card: {
    marginVertical: 4,
    color:'#5469215',
    width:width-30,

  },
  cardLayout:{
    flexDirection:'row',
    justifyContent:'space-between',

  },
  rightContainer:{
    flex:1,
    alignItems:'flex-start'
  },
  leftContainer:{
    alignItems:'flex-end'
  },
  centerContainer:{
    alignItems:'flex-start',
    flexDirection:'row'
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
